var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMileageDeviations(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2312 9.04159L10.4787 1.28914C10.0882 0.898614 9.45505 0.898614 9.06453 1.28914L1.31208 9.04159C0.921551 9.43212 0.921551 10.0653 1.31208 10.4558L9.06453 18.2083C9.45505 18.5988 10.0882 18.5988 10.4787 18.2083L18.2312 10.4558C18.6217 10.0653 18.6217 9.43212 18.2312 9.04159Z",
    stroke: "#959EB3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6912 12.1483C11.6912 12.6784 12.121 13.1082 12.6512 13.1082C13.1813 13.1082 13.6111 12.6784 13.6111 12.1483C13.6111 11.6181 13.1813 11.1883 12.6512 11.1883C12.121 11.1883 11.6912 11.6181 11.6912 12.1483ZM11.6912 12.1483H7.53152C7.10721 12.1483 6.70027 11.9797 6.40024 11.6797C6.1002 11.3796 5.93164 10.9727 5.93164 10.5484C5.93164 10.1241 6.1002 9.71712 6.40024 9.41708C6.70027 9.11704 7.10721 8.94849 7.53152 8.94849H11.3712C11.7107 8.94849 12.0362 8.81364 12.2763 8.57361C12.5163 8.33358 12.6512 8.00803 12.6512 7.66858C12.6512 7.32913 12.5163 7.00358 12.2763 6.76355C12.0362 6.52352 11.7107 6.38867 11.3712 6.38867H7.53152",
    stroke: "#959EB3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMileageDeviations);
export default __webpack_public_path__ + "static/media/mileage-deviations.f78f7ccff0eb8bdcf6909d8e8c8b352f.svg";
export { ForwardRef as ReactComponent };